
import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class TooltipButton extends Vue {
    @Prop({default: ""}) icon!: string;
    @Prop({default: ""}) text!: string;
    @Prop({default: false}) custom!: boolean;
    @Prop({default: ""}) btnStyle!: string;

    basicStyle = ` height: 36px; width: 40px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08); `
}
